import * as s from 'fp-ts/string';
export var fromString = function (s) { return s.toLowerCase(); };
export var Eq = s.Eq;
export var Semigroup = s.Semigroup;
export var Monoid = s.Monoid;
export var Ord = s.Ord;
export var Show = s.Show;
export var empty = '';
export var isEmpty = function (s) { return s.length === 0; };
export var size = function (s) { return s.length; };
